import { LiliTabs, TooltipPosition } from '@lili/lili-frontend-common';
import { IdentityUsForm } from '@Pages/happyFlowPages/identity/identityForm/us/IdentityUsForm.tsx';
import { IdentityNonUsForm } from '@Components/Identity/IdentityNonUsForm';
import type { ExtendedUseFormReturn } from '@Hooks/providers/useFormHooks.ts';
import type { IIdentityForm } from '@Lib/Identity/types';
import type { Country } from '@Types/country.ts';

export enum IdentityFormTypes {
  us,
  nonUs,
}

interface IdentityFormTypeSwitcherProps {
  formType: IdentityFormTypes;
  onFormTypeChanged: (formType: IdentityFormTypes) => void;
  isUsTabAllowed: boolean;
  formMethods: ExtendedUseFormReturn<IIdentityForm>;
  countryDataList: { title: string; value: string }[];
  selectedCountry: Country | undefined;
  isSwitchDisabled: boolean;
}

export const IdentityFormTypeSwitcher = ({
  formType,
  onFormTypeChanged,
  isUsTabAllowed,
  formMethods,
  selectedCountry,
  countryDataList,
  isSwitchDisabled,
}: IdentityFormTypeSwitcherProps) => {
  return (
    <div id='lili-tabs-wrapper' className='flex items-center w-full mb-[32px]'>
      <LiliTabs
        activeIndex={formType}
        onTabIndexChanged={(idx) => onFormTypeChanged(idx as IdentityFormTypes)}
        tabs={[
          {
            disabled: !isUsTabAllowed || isSwitchDisabled,
            content: (
              <div className='w-full pt-[32px]'>
                <IdentityUsForm />
              </div>
            ),
            toolTipData: !isUsTabAllowed
              ? {
                  content: 'A US resident is required to have a US mobile number',
                  position: TooltipPosition.BOTTOM,
                }
              : undefined,
            title: 'US Resident',
          },
          {
            disabled: isSwitchDisabled,
            content: (
              <div className='w-full pt-[32px]'>
                <IdentityNonUsForm
                  formMethods={formMethods}
                  selectedCountry={selectedCountry}
                  countryDataList={countryDataList}
                  owner={true}
                />
              </div>
            ),
            title: 'Non US Resident',
          },
        ]}
      />
    </div>
  );
};
